<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="BtnExtra">
            <!-- <button type="button" @click="GenerarInventario()" class="btn btn-sm btn-primary">
                <i class="fas fa-plus" aria-hidden="true"></i>
                Generar Inventario
            </button> -->
        </template>
        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
            <th :class="StyleTh">Mes</th>
            <th :class="StyleTh">Fecha Registro</th>
            <th :class="StyleTh">Fecha Autorización</th>
            <th :class="StyleTh">Estatus</th>
                
            <th :class="StyleTh+' text-center'">Acciones</th>
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                    <td><p :class="StyleTd">{{AjustarMes(lista.MesInventario)+' / '+lista.AnioInventario}}</p></td>
                    <td><p :class="StyleTd">{{$getCleanDate(lista.FechaRegistro,true)}}</p></td>
                    <td><p :class="StyleTd">{{lista.FechaAutorizacion == null ? '' : $getCleanDate(lista.FechaAutorizacion,true)}}</p></td>
                    <td><p :class="StyleTd">{{lista.Estatus}}</p></td>
                    
                <td class="align-middle text-end">
                    <CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="false" :pId="lista.Inventario" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
                        <template slot="btnaccion">
                            <!-- <button class="btn btn-link text-danger px-3 mb-0 mr-1">
                                <i class="fas fa-file-pdf text-danger me-2" aria-hidden="true"></i>PDF
                            </button> -->
                            <CMoreButtonsL>
                                <template slot="bodyBtnsL">
                                    <li v-if="lista.Estatus!='Autorizado'" @click="AutorizarInventario(lista)">
                                        <a class="dropdown-item">
                                            <i class="far fa-clipboard-check"></i> Cerrar Inventario
                                        </a>
                                    </li>
                                    <li @click="IrADesgloce(lista)">
                                        <a class="dropdown-item">
                                            <i class="far fa-clipboard-list"></i> Ver Desglose
                                        </a>
                                    </li>
                                </template>
                            </CMoreButtonsL>
                        </template>
                    </CBtnAccion>     
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="9"></CSinRegistros>
        </template>
    </CList>

</template>
<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionInventario';

export default {
    name: 'ListaInventarios',
    props: ['sFiltros','pOrigen'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Inventarios',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
                GoRoute: 'inventarioForm',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            Meses:[
                {clave:"01",label:"Enero"},
                {clave:"02",label:"Febrero"},
                {clave:"03",label:"Marzo"},
                {clave:"04",label:"Abril"},
                {clave:"05",label:"Mayo"},
                {clave:"06",label:"Junio"},
                {clave:"07",label:"Julio"},
                {clave:"08",label:"Agosto"},
                {clave:"09",label:"Septiembre"},
                {clave:"10",label:"Octubre"},
                {clave:"11",label:"Noviembre"},
                {clave:"12",label:"Diciembre"},
            ]
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("inventarios",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('inventarios/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        AutorizarInventario(item){
            this.$swal(Configs.configAutorizarInventario).then((result)=>{
                if (result.value) {
                    this.$http.post("inventarioAutorizar/"+item.IdInventario).then((res)=>{
                        this.$swal(Configs.configAutorizarInventarioConfirm);
                        this.Lista();
                    }).catch((err)=>{
                        this.$toast.error(err.response.data.message);
                    })
                }
            });
        },



        CambiarEstatusSalida(item,Tipo)
        {
            this.ConfigList.ShowLoader = true;

            let msg   = '';

            if(Tipo == '1'){
                msg = '¿Solicitar Cierre?';
            } else if(Tipo == '2') {
                msg = '¿Autorizar?';
            } else if(Tipo == '3') {
                msg = '¿Rechazar Salida?';
            }

            this.$swal({
                title: msg,
                text: 'Esta acción no se podra revertir',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
            }).then((result) => {
                if(result.value) {

                    this.$http.get("solicitudAlmacenEstatus",{
                        params:{
                            IdSolicitudAlmacen: item.IdSolicitudAlmacen,
                            Operacion: Tipo,
                        }
                    }).then((res) => {
                        this.$toast.success('Inventario Generado');
                        this.Lista();
                    }).finally(()=>{
                        this.ConfigList.ShowLoader = false;
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                }
                else{
                    this.ConfigList.ShowLoader = false;
                }
            });
        },
        GenerarInventario()
        {
             this.$swal({
                title: '¿Esta seguro de generar el inventario del mes actual?',
                text: '',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                showCloseButton: true,
            }).then((result) => {
                if(result.value) {

                    this.$http.get("inventarioGenerar",{
                        params:{
                            IdSolicitudAlmacen: 0,
                        }
                    }).then((res) => {
                        this.$toast.success('Inventario Generado');
                        this.Lista();
                    }).finally(()=>{
                        this.ConfigList.ShowLoader = false;
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                }
                else{
                    this.ConfigList.ShowLoader = false;
                }
            });
        },
        AjustarMes(Mes){
            let Index=this.Meses.findIndex((Element)=>Element.clave==Mes);
            return this.Meses[Index].label;
        },
        IrADesgloce(item){
            this.$router.push({name:'inventariodetalle',params:{pObjEnviado:item}});
        }
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
